import React from 'react';
import { Spacing16, Spacing24, Spacing8 } from 'autogen/design-tokens/tokens';
import { CarouselScrollButton, EmblaCarousel, Viewport } from 'components/emblaCarousel';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { useRegime } from './Regime';
import RegimeCardVertical from './RegimeCardVertical';

/* #region  styles */
const Container = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
`;

const StyledCarouselScrollButton = styled(CarouselScrollButton)<{ scrollType: 'next' | 'previous' }>`
    position: absolute;
    z-index: 1;
    right: ${({ scrollType }) => (scrollType === 'next' ? `-${Spacing8}` : 'unset')};
    left: ${({ scrollType }) => (scrollType === 'previous' ? `-${Spacing8}` : 'unset')};
    top: calc(50% + 20px);

    ${breakpoint.up(sizes.lg)} {
        right: ${({ scrollType }) => (scrollType === 'next' ? `-${Spacing24}` : 'unset')};
        left: ${({ scrollType }) => (scrollType === 'previous' ? `-${Spacing24}` : 'unset')};
    }
`;

const List = styled.div`
    display: grid;
    gap: ${Spacing16};
    grid-auto-flow: column;
    grid-auto-columns: 232px;
`;

const StyledViewport = styled(Viewport)``;
/* #endregion */

export default function RegimeCarousel({ children }) {
    const { productEntries } = useRegime();

    return (
        <Container>
            <EmblaCarousel options={{ align: 'start', containScroll: 'trimSnaps' }}>
                <StyledViewport>
                    <List>
                        {children}
                        {productEntries.map((product) => (
                            <RegimeCardVertical key={product.product.id} product={product} />
                        ))}
                    </List>
                </StyledViewport>

                <StyledCarouselScrollButton scrollType="next" />
                <StyledCarouselScrollButton scrollType="previous" />
            </EmblaCarousel>
        </Container>
    );
}
